import request from '../utils/request'

const PLATFORM_CHAR_LIMITS = {
  linkedin: 3000,
  instagram: 2200,
};

export const PLATFORMS = {
  linkedin: { key: 'linkedin', label: 'LinkedIn', charLimit: PLATFORM_CHAR_LIMITS.linkedin },
  instagram: { key: 'instagram', label: 'Instagram', charLimit: PLATFORM_CHAR_LIMITS.instagram },
};

export const ACCOUNTS = {
  personal: { key: 'personal', label: 'Personal' },
  business: { key: 'business', label: 'Business' },
};

export const POST_STATUSES = {
  draft: 'draft',
  pending_approval: 'pending_approval',
  approved: 'approved',
  queued: 'queued',
  publishing: 'publishing',
  posted: 'posted',
  failed: 'failed',
  canceled: 'canceled',
};

export const EDITABLE_STATUSES = new Set([
  POST_STATUSES.draft,
  POST_STATUSES.approved,
  POST_STATUSES.queued,
  POST_STATUSES.failed,
]);

export const TERMINAL_STATUSES = new Set([
  POST_STATUSES.posted,
  POST_STATUSES.canceled,
]);

export const REPOST_DELAY_OPTIONS = [
  { value: 0, label: 'Immediately' },
  { value: 1, label: '1 minute' },
  { value: 30, label: '30 minutes' },
  { value: 60, label: '1 hour' },
  { value: 120, label: '2 hours' },
  { value: 240, label: '4 hours' },
  { value: 1440, label: '24 hours' },
];

export const SocialPostService = {

  getPosts: async (params = {}) => {
    try {
      const response = await request.get('/social-posts', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching social posts:', error);
      throw error;
    }
  },

  getPostById: async (postId) => {
    try {
      const response = await request.get(`/social-posts/${postId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching social post:', error);
      throw error;
    }
  },

  createPost: async (postData) => {
    try {
      const response = await request.post('/social-posts', postData);
      return response.data;
    } catch (error) {
      console.error('Error creating social post:', error);
      throw error;
    }
  },

  updatePost: async (postId, updateData) => {
    try {
      const response = await request.patch(`/social-posts/${postId}`, updateData);
      return response.data;
    } catch (error) {
      console.error('Error updating social post:', error);
      throw error;
    }
  },

  deletePost: async (postId) => {
    try {
      const response = await request.delete(`/social-posts/${postId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting social post:', error);
      throw error;
    }
  },

  submitForApproval: async (postId) => {
    try {
      const response = await request.post(`/social-posts/${postId}/submit`);
      return response.data;
    } catch (error) {
      console.error('Error submitting post for approval:', error);
      throw error;
    }
  },

  approvePost: async (postId) => {
    try {
      const response = await request.post(`/social-posts/${postId}/approve`);
      return response.data;
    } catch (error) {
      console.error('Error approving post:', error);
      throw error;
    }
  },

  rejectPost: async (postId, note) => {
    try {
      const response = await request.post(`/social-posts/${postId}/reject`, { note });
      return response.data;
    } catch (error) {
      console.error('Error rejecting post:', error);
      throw error;
    }
  },

  queuePost: async (postId, scheduled_at) => {
    try {
      const response = await request.post(`/social-posts/${postId}/queue`, { scheduled_at });
      return response.data;
    } catch (error) {
      console.error('Error queueing post:', error);
      throw error;
    }
  },

  cancelPost: async (postId) => {
    try {
      const response = await request.post(`/social-posts/${postId}/cancel`);
      return response.data;
    } catch (error) {
      console.error('Error canceling post:', error);
      throw error;
    }
  },

  retryPost: async (postId) => {
    try {
      const response = await request.post(`/social-posts/${postId}/retry`);
      return response.data;
    } catch (error) {
      console.error('Error retrying post:', error);
      throw error;
    }
  },

  getStats: async () => {
    try {
      const response = await request.get('/social-posts/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching social post stats:', error);
      throw error;
    }
  },

  getLinkedInOAuthUrl: async () => {
    try {
      const response = await request.get('/social/oauth/linkedin/url', { withCredentials: true });
      return response.data;
    } catch (error) {
      console.error('Error fetching LinkedIn OAuth URL:', error);
      throw error;
    }
  },
};
